import { render } from "./BtnAtras.vue?vue&type=template&id=4b0c3203&scoped=true"
import script from "./BtnAtras.vue?vue&type=script&lang=js"
export * from "./BtnAtras.vue?vue&type=script&lang=js"

import "./BtnAtras.vue?vue&type=style&index=0&id=4b0c3203&scoped=true&lang=scss"

import exportComponent from "/home/cubel/PhpstormProjects/failder/vue-failder/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b0c3203"]])

export default __exports__